import LazyLoad from 'vanilla-lazyload';
import ButtonEvents from './modules/button-events';
import ConsentBar from './modules/general/consent-bar';
import { ReadConsentCookie } from './modules/general/consent-manager';
import Rwd from './modules/general/rwd';
import WidgetFacebook from './modules/general/widget-facebook';
import NewsletterPopup from './modules/newsletter-popup';
import NewsletterCookieModal from './modules/newsletter-cookie-modal';
import PjaxCode from './modules/pjax-code';
import PriceFiltering from './modules/price-filtering';
import ProductAdder from './modules/product-adder';
import DropdownPicker from './modules/dropdown-picker';
import Tabs from './modules/tabs';
import EventReceiver from './modules/utils/event-receiver';
import { WishlistBinding, WishlistDrawing } from './modules/wishlist';
import CalculateFreeShipment from './modules/general/calculate-free-shipment';
import QuestionForm from './modules/question-form';
import Showcase from './modules/general/showcase';
import initObserver from './modules/general/observer';
import VideoPlaceholders from './modules/video-placeholders';
import RmaForm from './modules/rma-form';
import Faqs from './modules/faqs';
import DetailMain from './modules/product-detail';

import HeaderBar from './modules/header-bar';
import mainpageDropdowns from './modules/mainpage-dropdowns';
import mainpagePriceSlider from './modules/mainpage-price-slider';
import footerMap from './modules/footer-map';

performance.mark("App start")

window.initConsent = ReadConsentCookie;

//available types of body: cart, listing, detail, mainpage, advanced-search, user-management, cms
const typeOf = document.body.getAttribute('data-type');

switch (typeOf) {
    case 'cart':
        import('./modules/cart/_index.js').then((module) => {
            module.cartDeliveryPoints();
            module.cartCommands();
            module.cartManagement();
            module.cartStepBubbles();
        });
        break;
    case 'user-management':
        import('./modules/management/_index.js').then((module) => {
            module.default();
        });
        break;
    case 'cms':
        break;
    case 'listing':
        PjaxCode();
        PriceFiltering();

        import('./modules/listing/filter-narrow-down').then((module) => {
            module.default();
        });

        break;
    case 'detail':
        DetailMain();
        break;
    case 'mainpage':
        mainpageDropdowns();
        mainpagePriceSlider();
        break;
    case 'advanced-search':
        import('./modules/advanced-search').then((module) => { module.default() });
        break;
    default:
        break;
}


ButtonEvents();
Rwd();
WidgetFacebook();
WishlistBinding();
WishlistDrawing();
DropdownPicker();
NewsletterPopup();
NewsletterCookieModal();
EventReceiver();
ProductAdder();
Tabs();
CalculateFreeShipment();
QuestionForm();
Showcase();
VideoPlaceholders();
Faqs();
footerMap();

HeaderBar();

// HEADER OBERVER
const header = document.querySelector('.shop-header');
const headerSentinel = document.querySelector('.header-sentinel');

if (header) {
    initObserver(headerSentinel, function () {
        header.classList.add('stuck');
    }, function () {
        header.classList.remove('stuck');
    });
}


// LAZY LOAD IMAGES
window.lazyLoadInstance = new LazyLoad({
    elements_selector: '.lazyload',
    unobserve_entered: true,
    cancel_on_exit: false,
});

// INIT TOOLTIPS
const tippyNeeded = document.querySelectorAll('[data-tippy-content]').length > 0;

if (tippyNeeded) {
    import('tippy.js').then((module) => {
        module.delegate('body', {
            target: '[data-tippy-content]',
            allowHTML: true
        });
    });
}

// LINKIFY CHAT
const threadMessages = document.querySelector('.thread-messages');

if (threadMessages) {
    import('linkify-html').then((module) => {
        const messages = threadMessages.querySelectorAll('.message-body');

        messages.forEach(function (message) {
            const text = message.textContent;
            const linkifiedText = module.default(text, { target: "_blank" });

            message.innerHTML = linkifiedText;
        });
    });
}





document.addEventListener("DOMContentLoaded", (event) => {
    ConsentBar();
});

RmaForm();



//import('./modules/polls').then((module) => { module.default() });
import('./modules/comparison').then((module) => { module.default() });
import('./modules/recaptcha').then((module) => { module.DrawInlineCaptcha() });
import('./modules/search-engine').then((module) => { module.default() });
import('./modules/treebox').then((module) => { module.default() });
import('./modules/return-to-top').then((module) => { module.default() });

// VALIDATIONS
const toValidateList = document.querySelectorAll('[data-run-validator]');

if (toValidateList.length > 0) {
    import('./modules/front-validation').then(module => module.default(toValidateList));
}




